import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';

import { A, P } from '../../../typography/new';

const FilterControl = ({ hasDisabledOptions }) => {
  const { DietaryPreferencesStore } = useRootStore();

  if (!hasDisabledOptions) {
    return null;
  }

  return (
    <P variant="standard" mb="8px">
      Showing dietary preferences
      <A variant="standard" ml="8px" onClick={() => DietaryPreferencesStore.clearDietaryPreferences()}>
        Clear filter
      </A>
    </P>
  );
};

FilterControl.propTypes = {
  hasDisabledOptions: PropTypes.bool.isRequired,
};

const ComposedFilterControl = observer(FilterControl);

export { ComposedFilterControl as FilterControl };
